import { render } from "./DialogCardAuthFailed.vue?vue&type=template&id=f799cb88"
import script from "./DialogCardAuthFailed.vue?vue&type=script&lang=js"
export * from "./DialogCardAuthFailed.vue?vue&type=script&lang=js"
script.render = render

export default script